var _path, _path2, _path3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNownow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 303,
    height: 47,
    viewBox: "0 0 303 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4072_27432)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M272.319 11.0327L261.708 31.8225L260.131 11.0374H250.116L254.171 45.5767H263.015L273.918 24.5282L276.549 45.5689H285.458L302.996 11.0295H293.177L283.422 31.8856L280.845 11.0327H272.319Z",
    fill: "#F78B00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M208.248 0.797012L199.623 28.3607L187.27 0.797012H178.407L164.478 45.5626H174.197L182.801 17.1046L195.872 45.5641H204.25L217.971 0.797012H208.248Z",
    fill: "#F78B00"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4072_27432",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 303,
    height: 47
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M302.995 0.796997H0.700928V46.083H302.995V0.796997Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4072_27432)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M228.509 46.0846C217.893 46.0846 210.985 38.2178 212.185 28.3701L212.201 28.2424C212.933 23.2624 215.44 18.7145 219.259 15.4358C223.078 12.1571 227.953 10.3683 232.986 10.3986C243.602 10.3986 250.51 18.2638 249.31 28.1131L249.294 28.2408C248.562 33.2206 246.055 37.7683 242.236 41.0468C238.417 44.3252 233.542 46.1137 228.509 46.083M239.707 28.2408C240.323 23.194 237.215 18.778 231.843 18.778C229.309 18.8063 226.877 19.779 225.022 21.5058C223.168 23.2326 222.024 25.5892 221.815 28.1146L221.8 28.2424C221.185 33.2892 224.292 37.7052 229.663 37.7052C232.197 37.6769 234.629 36.7042 236.484 34.9774C238.338 33.2506 239.482 30.894 239.691 28.3686L239.707 28.2408Z",
    fill: "#F78B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6521 45.5625L53.5808 17.1046L44.9727 45.5625H35.2528L49.0843 0.796997H58.0488L70.3994 28.3607L79.0216 0.796997H88.7415L75.0299 45.5641L66.6521 45.5625Z",
    fill: "#24272A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2842 46.0846C88.6685 46.0846 81.7606 38.2178 82.9608 28.3701L82.9766 28.2424C83.7084 23.2623 86.2146 18.7142 90.0339 15.4354C93.8531 12.1567 98.7282 10.368 103.762 10.3986C114.377 10.3986 121.285 18.2638 120.085 28.1131L120.069 28.2408C119.337 33.2206 116.831 37.7683 113.012 41.0468C109.192 44.3252 104.317 46.1137 99.2842 46.083M110.482 28.2408C111.099 23.194 107.99 18.778 102.618 18.778C100.084 18.8063 97.6523 19.779 95.7977 21.5058C93.9432 23.2326 92.7996 25.5892 92.5908 28.1146L92.5751 28.2424C91.96 33.2892 95.0669 37.7052 100.439 37.7052C102.973 37.6769 105.405 36.7042 107.259 34.9774C109.114 33.2506 110.257 30.894 110.466 28.3686L110.482 28.2408Z",
    fill: "#24272A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.053 45.572H151.292L144.706 24.5298L137.99 45.5704H129.294L118.741 11.0311H128.59L134.091 31.8162L140.558 11.0263H148.935L155.459 31.8793L161.086 11.0311H170.728L160.053 45.572Z",
    fill: "#24272A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6966 11.0516C22.5578 11.0516 21.4657 11.5039 20.6605 12.3092C19.8552 13.1144 19.4028 14.2065 19.4028 15.3453C19.4028 16.4841 19.8552 17.5762 20.6605 18.3815C21.4657 19.1867 22.5578 19.6391 23.6966 19.6391H38.7756L41.4347 11.0516H23.6966Z",
    fill: "#F78B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.99657 24.0046C3.85779 24.0046 2.76566 24.457 1.96042 25.2622C1.15518 26.0675 0.702805 27.1596 0.702805 28.2984C0.702805 29.4371 1.15518 30.5293 1.96042 31.3345C2.76566 32.1398 3.85779 32.5921 4.99657 32.5921H34.7667L37.421 24.0046H4.99657Z",
    fill: "#F78B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.83656 36.9561C8.69779 36.9561 7.60565 37.4085 6.80041 38.2137C5.99518 39.0189 5.5428 40.1111 5.5428 41.2499C5.5428 42.3886 5.99518 43.4808 6.80041 44.286C7.60565 45.0912 8.69779 45.5436 9.83656 45.5436H30.7684L33.4227 36.9561H9.83656Z",
    fill: "#F78B00"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4072_27432"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 302.294,
    height: 45.286,
    fill: "white",
    transform: "translate(0.700928 0.796997)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNownow);
export default __webpack_public_path__ + "static/media/nownow.b1e83e23f3c765112a9d7770b3e16d8d.svg";
export { ForwardRef as ReactComponent };